// @ts-nocheck
import * as types from '../types';

const initialState = {
    logs: [],
    operationLogs: [],
    logsDetails: {},
    isDrawerVisible: false,
    operationLogsDrawerVisibility: false,
    fetchData: () => {},
    cashier: {},
    tickets: [],
    terminalTickets: [],
    loginHistory: [],
    transactions: [],
    terminalTransactions: [],
    terminal: {},
};

const logs = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case types.LOGS_DETAILS_CHANGED: {
            return {
                ...state,
                ...payload,
            };
        }
        case types.LOGS_CHANGED: {
            return {
                ...state,
                logs: [...state.logs, ...payload],
            };
        }
        case types.OPERATION_LOGS_CHANGED: {
            return {
                ...state,
                operationLogs: [...state.operationLogs, ...payload],
            };
        }
        case types.LOGS_CLEARED: {
            return {
                ...state,
                pageOffset: initialState.pageOffset,
                logsDetails: initialState.logsDetails,
                fetchData: initialState.fetchData,
                hasMore: initialState.hasMore,
                logs: initialState.logs,
                operationLogs: initialState.operationLogs,
            };
        }
        case types.LOGS_CASHIER_DATA_CHANGED: {
            return {
                ...state,
                cashier: action.payload,
            };
        }
        case types.LOGS_TERMINAL_DATA_CHANGED: {
            return {
                ...state,
                terminal: action.payload,
            };
        }
        case types.LOGS_CASHIER_TICKETS_CHANGED: {
            return {
                ...state,
                tickets: payload,
            };
        }
        case types.LOGS_TERMINAL_TICKETS_CHANGED: {
            return {
                ...state,
                terminalTickets: payload,
            };
        }
        case types.LOGS_CASHIER_LOGIN_HISTORY_CHANGED: {
            return {
                ...state,
                loginHistory: payload,
            };
        }
        case types.LOGS_CASHIER_TRANSACTIONS_CHANGED: {
            return {
                ...state,
                transactions: payload,
            };
        }
        case types.LOGS_TERMINAL_TRANSACTIONS_CHANGED: {
            return {
                ...state,
                terminalTransactions: payload,
            };
        }
        default:
            return state;
    }
};

export default logs;
